export default "__VITE_ASSET__CuPnbxLa__"